// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__vctuy","darkContainer":"Layout_darkContainer__PIOKw","darkMain":"Layout_darkMain__yAywV"};